import { FormStepType } from "./types";
import { applicant_details } from "./steps/applicant-details";
import { contact_information } from "./steps/contact-information";
import { passport_details_corrections } from "./steps/passport-details-corrections";

export const form_ds_5504: FormStepType[] = [
  applicant_details,
  contact_information({ additionalPhoneNumbers: 2 }),
  passport_details_corrections,
];
